import React, {useContext, useState} from 'react';
import LandingPage from '../../Pages/LandingPage';
import {ThemeContext} from '../../themes/ThemeProvider';
import ViewOrganization from './View';
import Organization from './Organization/index';
import {useSelector} from 'react-redux';
import {useLocation} from 'react-router';

const index = () => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [tabValue, setTabValue] = useState(0);
  const [siteTableData, setSiteTableData] = useState([]);
  const [orgType, setOrgType] = useState(null);
  const [id, setId] = useState(null);
  const [edit, setEdit] = useState(false);
  const location = useLocation();

  const tenants = location.pathname === '/client-tenants';
  const {roleData} = useSelector(({role}) => role);
  const organizationAccess = tenants ?
    roleData?.window?.['Client Management']?.['TE'] :
    roleData?.window?.['Client Management']?.['CLMGM'];

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <>
      <LandingPage
        title={tenants ? 'Tenants / RevOne Companies' : 'Client Maintenance'}
        showTabs={true}
        tabValue={tabValue}
        handleTabChange={handleChange}
      >
        <div className="global-field-dash-board">
          <div className={` ${classes.cardStyleWhite}`}>
            <div className={classes.root}>
              <div className={classes.subContent}>
                {tabValue === 0 && (
                  <Organization
                    setTabValue={setTabValue}
                    setOrgType={setOrgType}
                    orgType={orgType}
                    setId={setId}
                    setEdit={setEdit}
                    tenants={tenants}
                    setSiteTableData={setSiteTableData}
                    organizationAccess={organizationAccess}
                  />
                )}
              </div>
              <div className={classes.subContent}>
                {tabValue === 1 && (
                  <ViewOrganization
                    edit={edit}
                    setTabValue={setTabValue}
                    setOrgType={setOrgType}
                    orgType={orgType}
                    id={id}
                    siteTableData={siteTableData}
                    organizationAccess={organizationAccess}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </LandingPage>
    </>
  );
};
export default index;
